module.exports = __webpack_public_path__ + "static/media/aboutComp.62699742.pdf";